import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';

export const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#f7f7f7]">
      <Header />
      <div className="max-w-4xl mx-auto pt-32 p-8 text-black">
        <div className="space-y-6">
          <p className="text-lg">
            I'm a French creative developer, currently in my second year of a
            Master's in Interactive Development (Technical Lead) at Gobelins,
            and doing an apprenticeship at Bonhomme. <br />
            <br />
            I'm specializing in interactive websites with a strong focus on
            animation, interaction, and performance to create immersive, dynamic
            experiences.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};
